<template>
  <review-card :key="`list-group-crom-${expanded}`" title="Cromossomos(as)">
    <v-list-group
      v-for="(item, index) in chromosomes"
      :key="index"
      class="item-par"
      :value="expanded"
    >
      <template v-slot:activator>
        <v-list-item-title>
          Cromossomo(a) {{ item.chromosome.order }}
        </v-list-item-title>
      </template>
      <div class="py-3 grey--text text--darken-3">
        <property-value
          property="Descrição"
          :value="item.chromosome.description"
        />
        <property-value
          property="Comentários aos terapeutas"
          :value="item.therapistComments"
        />
        <property-value
          property="Comentários ao paciente"
          :value="item.patientComments"
        />
      </div>
    </v-list-group>
  </review-card>
</template>

<script>
export default {
  name: "Chromosomes",
  props: {
    chromosomes: {
      type: Array,
      default: () => [],
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
